"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openProductInfoDialog = void 0;
var _openProductInfoDialog = _interopRequireWildcard(require("@ori-events/open-product-info-dialog"));
var OpenProductInfoDialog = _openProductInfoDialog;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// istanbul ignore file @preserve --event dispatch function

const openProductInfoDialog = (productCode, analyticsData) => () => window.dispatchEvent(new CustomEvent(OpenProductInfoDialog.Name, {
  detail: {
    mode: _openProductInfoDialog.DialogMode.StandardBuy,
    placement: analyticsData?.placement,
    position: analyticsData?.position,
    productCodes: [productCode]
  }
}));
exports.openProductInfoDialog = openProductInfoDialog;
